/**
 * A MEDIAESZKOZ-HIBAK EMBERI SZOVEGE.
 *
 * A bongeszo es a LiveKit angol, technikai uzenetet ad ("Permission denied by user",
 * "Timeout starting video source"). Ez a felhasznalonak nem mond semmit - nem tudja,
 * mit tegyen vele. Itt a leggyakoribb esetekhez azt is megmondjuk, MI A TEENDO.
 *
 * Mind a megosztas, mind a mikrofon/kamera hibaja ide jon, hogy ugyanaz a szoveg
 * jelenjen meg, akarhonnan jott is.
 */

export type MediaErrorSource = 'microphone' | 'camera' | 'screen';

const SOURCE_LABEL: Record<MediaErrorSource, string> = {
  microphone: 'mikrofon',
  camera: 'kamera',
  screen: 'képernyőmegosztás',
};

/** A LiveKit `MediaDeviceKind`-jabol (audioinput / videoinput) a forras. */
export function sourceFromKind(kind: string | undefined, message: string): MediaErrorSource {
  // A kepernyomegosztas a LiveKitben is "videoinput"; az indulasi idotullepes jellemzoje.
  if (/starting video source/i.test(message)) return 'screen';
  return kind === 'audioinput' ? 'microphone' : 'camera';
}

export function describeMediaError(error: Error, source: MediaErrorSource): string {
  const name = error.name;
  const message = error.message;

  // A forras nem adott kepet: tipikusan minimalizalt vagy valtozatlan ablak, vagy GPU-gond.
  if (/starting video source/i.test(message)) {
    return (
      'A képernyőmegosztás nem indult el: a kiválasztott forrásból nem érkezett kép. ' +
      'Próbáld a teljes képernyőt megosztani, vagy válassz másik (nem minimalizált) ablakot.'
    );
  }

  if (name === 'NotAllowedError' || /permission (denied|dismissed)/i.test(message)) {
    return source === 'screen'
      ? 'A képernyőmegosztást a böngésző nem engedte. Próbáld újra, és válassz forrást.'
      : `A ${SOURCE_LABEL[source]} nem érhető el: a böngésző nem adott engedélyt. ` +
          `Kattints a címsor melletti ikonra, engedélyezd a ${SOURCE_LABEL[source]}ot, ` +
          'majd kapcsold be újra.';
  }

  if (name === 'NotFoundError' || name === 'OverconstrainedError') {
    return `Nem találom a ${SOURCE_LABEL[source]} eszközét (kihúzták, vagy átállt másra a rendszer).`;
  }

  if (name === 'NotReadableError' || name === 'AbortError') {
    return `A ${SOURCE_LABEL[source]} eszközét egy másik program használja, vagy nem indul el.`;
  }

  return `${SOURCE_LABEL[source][0]!.toUpperCase()}${SOURCE_LABEL[source].slice(1)}-hiba: ${message}`;
}
